module.exports = (__webpack_require__(3))(45);


//////////////////
// WEBPACK FOOTER
// delegated ./src/models/CollectionModel.js from dll-reference girder_lib
// module id = 53
// module chunks = 0